import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Seller } from "./Seller";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable()
export class SellerService {
  private url: string = environment.baseUrl + "/v1/sellers";

  private companies: String[] = [];
  private teams: String[] = [];

  public cachedSellers: Seller[] = [];

  constructor(private httpClient: HttpClient) {}

  getRequestHeaders(): HttpHeaders {
    var token = localStorage.getItem("accessToken");
    const requestHeaders = new HttpHeaders()
      .set("Authorization", "Bearer " + token)
      .set("Content-Type", "text/plain; charset=iso-8859-1");
    return requestHeaders;
  }

  getSellers(): Observable<Seller[]> {
    return this.httpClient
      .get(this.url, {
        headers: this.getRequestHeaders(),
      })
      .map((response) => {
        return this.mapSellers(response);
      });
  }

  updateSeller(seller: Seller) {
    return this.httpClient.put(this.url, JSON.stringify(seller), {
      headers: this.getRequestHeaders(),
    });
  }

  saveNewSeller(seller: Seller) {
    return this.httpClient.post(this.url, JSON.stringify(seller), {
      headers: this.getRequestHeaders(),
    });
  }

  getCompanies(): String[] {
    return this.companies;
  }

  getTeams(): String[] {
    return this.teams;
  }

  private mapSellers(sellers): Seller[] {
    var res: Seller[] = [];
    sellers.forEach((seller) => {
      var newSeller = Seller.createFromResponse(seller);
      this.addUniqueCompany(newSeller.company);
      this.addUniqueTeam(newSeller.team);
      this.cachedSellers.push(newSeller);
      res.push(newSeller);
    });

    this.companies.sort();
    this.teams.sort();
    return res;
  }

  private addUniqueCompany(company: String) {
    if (!this.companies.includes(company)) {
      this.companies.push(company);
    }
  }

  private addUniqueTeam(team: String) {
    if (!this.teams.includes(team)) {
      this.teams.push(team);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-sellers/admin-seller-service.service.ts